export default __webpack_public_path__ + "static/heroKusamaVector-6d0d5eeab814e32246e1f225b9241ae2.svg";